module.exports = __webpack_public_path__ + "static/img/zusaetzlicherschutz.838fcbca.svg";